export const EContributionType = {
  DOLLARS: "dollars",
  PERCENTAGE: "percentage",
} as const;

export type EContributionType =
  (typeof EContributionType)[keyof typeof EContributionType];

export const EContributionTypeMembers = Object.values(EContributionType);
